import React from "react";
import { printImg } from "../../master/Print";
import useAppConfig from "../../config/useAppConfig";
import EnquiryDemoForm1 from "../components/EnquiryDemoForm1";
import EnquiryDemoForm2 from "../components/EnquiryDemoForm2";
import usePrivateLink from "../../config/usePrivateLink";

export default function EnquiryDemoForm({ data }) {
  const config = useAppConfig("Enquiry", "enquiry_demo_form");
  const hasAccess = usePrivateLink();

  return (
    <div className="card">
      <div className="card-body">
        <div className="row">
          <div className="col-12 text-end mb-1">
            {hasAccess("/enquiry/form/print") && (
              <button
                className="btn btn-info"
                onClick={() => printImg("PrintDiv")}
              >
                <i className="ri-printer-line"></i>
              </button>
            )}
          </div>
          <div className="col-12">
            {config?.value === "enquiry_demo_form_1" ? (
              <EnquiryDemoForm1 data={data} />
            ) : config?.value === "enquiry_demo_form_2" && (
              <EnquiryDemoForm2 data={data} />
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
